export default "__VITE_ASSET__T1uBnIWt__"